/**
 * Показать ответ ♪ тостом (`revoiceReply`) и записать его в консоль — по ней ответ видят и агенты проверки (проба
 * P50m10d: тост мог исчезнуть, пока вкладка подвисала). Один тост на реплику: повторный ♪ заменяет прежний.
 */
import type { ToastArgs } from "../NotificationProvider/NotificationProvider";
import { revoiceReply } from "./revoiceReply";

interface Notifier {
    openToast?: (toast: ToastArgs) => void;
    openNotification?: (text: string) => void;
    openErrorNotification?: (text: string) => void;
}

const DURATION_SEC = { success: 10, warning: 20, error: 20 } as const;

export const showRevoiceReply = (notify: Notifier | null | undefined, result: unknown, cueId: string | null, en = false) => {
    const reply = revoiceReply(result, en);
    const log = reply.type === "error" ? console.error : reply.type === "warning" ? console.warn : console.info;
    log("[♪] reply", { cue: cueId, ...reply });
    if (notify?.openToast) {
        notify.openToast({ ...reply, duration: DURATION_SEC[reply.type], key: `revoice-${cueId || ""}` });
    } else if (reply.type === "error") {
        notify?.openErrorNotification?.(`${reply.message}: ${reply.description}`);
    } else {
        notify?.openNotification?.(`${reply.message}: ${reply.description}`);
    }
    return reply;
};
